import React, { useState } from "react";

interface CollapsibleSectionProps {
  title: string;
  defaultExpanded?: boolean;
  titleColor?: string;
  children: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  defaultExpanded = false,
  titleColor = "black",
  children,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div
      style={{
        margin: "0 10px 20px", // margen lateral para mobile
        /* border: "1px solid #ccc", */
        borderRadius: "10px",
        overflow: "hidden",
        boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
      }}
    >
      <div
        style={{
          backgroundColor: "#f0f0f0",
          padding: "10px 20px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <h3 style={{ margin: 0, color: titleColor }}>{title}</h3>
        <span
          style={{
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        >
          ▼
        </span>
      </div>
      {expanded && <div style={{ padding: "20px" }}>{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
